<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-habit-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h6 class="modal-title" id="myModalLabel" v-html="'Record Your Performance:&nbsp;on your <em>' + currenthabitdata.name + '</em> Habit'" ></h6>
        </div>
        <div class=" content modal-body">
          <div class="embed-responsive"> <!-- embed-responsive-16by9 -->
                <p><em>Habit Name:</em> {{currenthabitdata.name}}<br/>
                Purpose:<i>{{currenthabitdata.description}}</i><br/>
               <em>Check Frequency:</em> {{currenthabitdata.frequency}}</p>
                <div  class="card" v-if="currenthabitdata">
                    <h5  class="header-box-msg  text-center">Click those you've done:</h5>
                    <div v-for="component in currenthabitdata.components" :key="component.id">
                        <button :id="component.id" class="btn btn-sm btn-default tracker-btn" style="margin:auto;"
                            v-on:click="trackDone(component.id, component.weight)" ><b>{{component.name}}:</b> ({{component.description}}, <em>{{component.weight}} points</em>.)
                        </button>
                        <div hidden :id="'div'+component.id" ><small><span style="color:#55060e;">Recorded: </span><b>{{component.name}}:</b> ({{component.description}}, <em>{{component.weight}} points</em>.)</small></div>
                    </div>
                </div>
                <button @click="cancel()" class="btn btn-sm btn-warning float-right">Close &nbsp;<i class="fas fa-times"></i></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import axios from 'axios';
import Errors from '../../partials/Errors.vue';
import Swal from 'sweetalert2';
// var _ = require('lodash');

export default {
    components: { Errors,
    },
    name: "HabitTrackerModal",
    data() {
        return {
            currenthabitdata:[],
        }
    },
    props: {
    },
    mounted() {
        EventBus.$on('displayHabitTrackerModal', (data) => {
            // console.log("In HabitTrackerModal: "+ data.habitdata);
            this.currenthabitdata = data.habitdata;
             this.userdata = data.userdata;
            $('div#display-habit-modal').modal('show');
        });
    },
    methods: {
        cancel() {
            $('div#display-habit-modal').modal('hide');
        },
         informChart(newdata) {
             this.$root.$emit('updateChart', newdata);
        },
        disableClickedButton(compid) {
            document.getElementById(compid).hidden = true;
            document.getElementById('div'+compid).hidden = false;
        },

        trackDone(compid, compweight) {
            let incomingdata = '';
            // console.error("Tracking habit_component:id: " + compid + ", wt:" + compweight + ", habitID: " + this.currenthabitdata.id);
            axios.post('/habits/tracking/update', {
                user_id:this.userdata.id,
                component_id: compid,
                points: compweight,
                habit_id: this.currenthabitdata.id,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.failure = false;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(() => {
                    //  console.error('In delete finally.....');
                    // console.error(incomingdata);
                    this.disableClickedButton(compid);
                    // this.informChart();
                    this.$forceUpdate();
                });
        },
        startTracking(habit_id) {
        },



        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
